import { DashboardScheduleIcon } from '@/Components/Common/Icons/DashboardScheduleIcon';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import '../Dashboard.less';
import Alerts from './Alerts/Alerts';
import RecentActivity from './RecentActivity/RecentActivity';
import WeatherCard from './Schedule/WeatherCard';
import TaskComplianceSection from './TaskCompliance/TaskComplianceSection';

const Home = (props) => {
  const trans = useSelector(translator);

  return (
    <div className="home-content">
      <Alerts {...props} />

      <div className="schedule-weather-section">
        <div className="section-header">
          <DashboardScheduleIcon className="section-icon" />
          <h3 className="section-title">{trans('SCHEDULE')}</h3>
        </div>
        <WeatherCard {...props} />
      </div>

      <RecentActivity {...props} />

      <TaskComplianceSection {...props} />
    </div>
  );
};

Home.propTypes = {
  timezone: PropTypes.string,
  is24HourFormat: PropTypes.bool,
  useruuid: PropTypes.string,
  locale: PropTypes.string,
  hubRecord: PropTypes.object,
  measurementSystem: PropTypes.string,
  userStateList: PropTypes.object,
  hc200DeviceUuid: PropTypes.string,
  accessories: PropTypes.arrayOf(PropTypes.object),
  isAlertsApplicable: PropTypes.bool,
  redirectToAlertsTab: PropTypes.func,
  supportedCategories: PropTypes.array,
};

export default Home;
